
import { Component, Vue } from 'vue-property-decorator'
import store from '@/store/store'
import { isCurrentOrPastMember, type MembershipWithEntity, mostRecentMemberships } from '@/state/Membership'
import { API } from '@/api/API'
import { groupBy, indexItemsById } from '@/helpers/IndexHelpers'
import { getMembershipRules, type MembershipRules } from '@/api/Membership'
import MyMembership from '@/components/membership/PurchasedMembership.vue'

// TODO Clean up names of MyMembership and PurchasedMembership types and components.

@Component({
  components: { MyMembership },
})
export default class MembershipDetailsRoute extends Vue {
  loading: boolean = false
  ticketTypes: TicketType[]
  savedPaymentMethodsResponse: ApiResponse<'saved_payment_method'> | null = null
  membershipRules: MembershipRules | null = null

  async created() {
    if (this.hasMembership) {
      this.loading = true
      this.initSavedPaymentMethods().finally(() => {
        this.loading = false
      })

      this.membershipRules = await this.fetchMembershipRules()
    }
  }

  get memberships(): MembershipWithEntity[] {
    return mostRecentMemberships()
  }

  get tickets(): Dict<Ticket[]> {
    return groupBy('ticket_order_id', store.getters['Member/allTickets'])
  }

  async fetchMembershipRules(): Promise<MembershipRules> {
    // Only fetch rules for ticket types that are actually used for current member.
    const typesById: Dict<TicketType> = indexItemsById(store.getters['Member/ticketTypes'])
    return getMembershipRules({ 'ticket_type.id._in': Object.keys(typesById) })
  }

  async initSavedPaymentMethods(): Promise<void> {
    this.savedPaymentMethodsResponse = await API.getUncached<'saved_payment_method'>(
      'my/identity/saved_payment_method',
    )
  }

  // TODO Is there really only one membership scan code per user, even if they have multiple memberships?
  get membershipScanCode(): string {
    return store.getters['Member/membershipScanCode']
  }

  get savedCard(): SavedPaymentMethod | undefined {
    return this.savedPaymentMethodsResponse!.saved_payment_method._data[0]
  }

  get hasMembership(): boolean {
    return isCurrentOrPastMember()
  }
}
